import React, { ReactNode, memo, useRef, useState } from 'react';
import { ReactSVG } from 'react-svg';

import './style.sass';

import dropArrowIcon from 'assets/img/icons/drop-arrow.svg';
import { useOnClickOutside } from 'app/hooks/useOnClickOutside';

type Props = {
    isActive: boolean,
    setIsActive: (v: boolean) => void,
    className?: string;
    buttonClassName?: string,
    listClassName?: string,
    button: ReactNode;
    children: ReactNode;
    directionX?: 'left' | 'right';
    directionY?: 'top' | 'bottom';
    title?: string,
    type?: 'default' | 'white';
    hasArrow?: boolean,
};

export const Dropdown = memo(({
    isActive,
    setIsActive,
    className,
    button,
    children,
    buttonClassName,
    listClassName,
    directionX = 'left',
    directionY = 'bottom',
    title,
    type = 'default',
    hasArrow = true,
}: Props) => {
    const dropdownBtnRef = useRef<HTMLDivElement | null>(null);

    useOnClickOutside(dropdownBtnRef, () => setIsActive(false));

    const handleToggleDropdown = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        setIsActive(!isActive);
    };

    const dropdownClass = 'dropdown'
    + ` ${className ? className : ''}`
    + ` ${directionX}-direction`
    + ` ${directionY}-direction`
    + ` dropdown--${type}`;

    const listClass = `dropdown__list ${isActive ? 'active' : ''} ${listClassName ? listClassName : ''}`;
    const dropIconClass = `dropdown__open-icon ${isActive ? 'active' : ''}`;
    const buttonClass = `dropdown__button ${buttonClassName ? buttonClassName : ''}`;

    return (
        <div className={dropdownClass} ref={dropdownBtnRef}>
            <div className={buttonClass} onClick={handleToggleDropdown}>
                {button}

                {hasArrow &&
                    <div className={dropIconClass}>
                        <ReactSVG src={dropArrowIcon} />
                    </div>
                }
            </div>

            {isActive && <ul className={listClass}>
                {title && <span className="dropdown__title grey-1 p2-regular">{title}</span>}

                {children}
            </ul>}
        </div>
    );
});
